import axios from "axios";
import { FILE_API_URL, FILE_UPLOAD_API_URL } from "../utils/constants";

export const FILE_BUCKETS = Object.freeze({
  ALUMNI: "ALUMNI",
  GRIEVANCE: "GRIEVANCE",
});

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.message || error?.message || fallback;

/** Uploads one file and returns the API's `data` object (file metadata). */
export const uploadFile = async (file, bucket) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await axios.post(FILE_UPLOAD_API_URL, formData, {
      params: { bucket },
      headers: {
        Accept: "*/*",
        "ngrok-skip-browser-warning": "true",
      },
    });

    if (!response.data?.success || !response.data?.data?.objectPath) {
      throw new Error(response.data?.message || "File upload failed.");
    }

    return response.data.data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "Unable to upload the file. Please try again."));
  }
};

/** Removes an uploaded object using the bucket and objectPath returned by uploadFile. */
export const deleteUploadedFile = async ({ bucket, objectPath }) => {
  if (!bucket || !objectPath) {
    throw new Error("The uploaded file information is incomplete.");
  }

  try {
    const response = await axios.delete(FILE_API_URL, {
      params: { bucket, objectPath },
      headers: {
        Accept: "*/*",
        "ngrok-skip-browser-warning": "true",
      },
    });

    if (response.data?.success === false) {
      throw new Error(response.data?.message || "File removal failed.");
    }
  } catch (error) {
    throw new Error(getErrorMessage(error, "Unable to remove the file. Please try again."));
  }
};
